import request from '../utils/request'

/**
 * 获取数据报表概览
 */
export function getReportOverview() {
  return request({
    url: '/manager/report/overview',
    method: 'get'
  })
}

/**
 * 获取客户统计数据
 */
export function getCustomerStatistics() {
  return request({
    url: '/manager/report/customer-statistics',
    method: 'get'
  })
}

/**
 * 获取客户意向等级分布
 */
export function getIntentionLevelDistribution() {
  return request({
    url: '/manager/report/intention-level-distribution',
    method: 'get'
  })
}

/**
 * 管理端数据看板（新版）
 * @param {Object} params { startDate, endDate, salesmanIds } - salesmanIds 可以是逗号分隔的字符串或数组
 */
export function getManagerDashboard(params) {
  return request({
    url: '/manager/report/dashboard',
    method: 'get',
    params
  })
}

